import { AfterViewInit, Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { FormatOdometerNumber } from '../../../../assets/functions/format-odometer-number';
import { CountryName } from '../../../../assets/functions/get-country-name';
import { OnlyAcceptNumbers } from '../../../../assets/functions/only-accept-numbers';
import { ConstantsFordProtect } from '../../../models/constants/constants-ford-protect';
import { CoverageCategoryEdit } from '../../../models/product/coverage-category-edit';
import { ApsPermissionService } from '../../../services/aps-permission/aps-permission.service';
import { CoverageService } from '../../../services/coverage/coverage.service';

type DropdownChangeEvent<T> = {
  value: T;
};

@Component({
  selector: 'app-coverage-details-edit',
  templateUrl: './coverage-details-edit.component.html',
  styleUrls: ['./coverage-details-edit.component.scss'],
  standalone: false
})
export class CoverageDetailsEditComponent implements OnInit, AfterViewInit {
  private readonly destroyRef = inject(DestroyRef);

  inputCoverageName: string | undefined | null = '';
  inputCoverageDescription: string | undefined | null = '';
  selectTypeCoverage: string | undefined | null = '';
  selectTypeCoverageGet: string = '';
  inputOwsCoverage: string | undefined | null = '';
  inputMonths: number | undefined | null = 0;
  inputDistance: number | undefined | null = 0;
  inputDistanceString: string | undefined | null = '';
  inputTotalVisits: number | undefined | null = 0;
  inputInitialVisit: number | undefined | null = 0;
  inputAccount: string | null = '';
  inputActionCode: string | null = '';
  inputCoverageCode: string | null = '';
  inputInsuranceCode: string | undefined = '';
  coverage: CoverageCategoryEdit = {} as CoverageCategoryEdit;
  editedCoverage: CoverageCategoryEdit = {} as CoverageCategoryEdit;
  productName: string = '';
  blockedUi = false;
  editionEnabled = true;
  isEditingMode = false;
  hasAttemptedSave = false;

  selectDisabled = false;
  countryNameResult: string = '';
  distanceFormatted: string = '';

  listTypeCoverage = [
    { label: 'TRANSLATE.SELECT' },
    { label: 'TRANSLATE.UPPERCASE.MAINTENANCE', value: ConstantsFordProtect.MAINTENANCE },
    { label: 'TRANSLATE.UPPERCASE.EXTENSION', value: ConstantsFordProtect.EXTENSION },
    { label: 'TRANSLATE.UPPERCASE.REPAIRS', value: ConstantsFordProtect.REPAIRS },
    { label: 'TRANSLATE.UPPERCASE.SIGNALS', value: ConstantsFordProtect.SIGNALS },
    { label: 'TRANSLATE.UPPERCASE.WINCHES', value: ConstantsFordProtect.WINCHES },
    { label: 'TRANSLATE.UPPERCASE.WEAR', value: ConstantsFordProtect.WEAR }
  ];

  id: number = 0;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private coverageService: CoverageService,
    private apsPermissionService: ApsPermissionService,
    private translateService: TranslateService,
    private messageService: MessageService,
    private countryName: CountryName,
    private formatDistance: FormatOdometerNumber,
    private onlyAcceptNumbers: OnlyAcceptNumbers

  ) {
    this.route.paramMap.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(params => {
      this.id = +(params.get('id') ?? '0');
    })
  }

  ngOnInit() {

    this.getCoverageById();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.buttonCancel();
    }, 0);
  }

  buttonReturn() {
    this.router.navigate(['view-plans'], { skipLocationChange: false, replaceUrl: false });
  }

  buttonEdit() {
    this.isEditingMode = true;
    this.hasAttemptedSave = false;
    this.clearValidationState();

    (document.getElementById("coverageIdName") as HTMLInputElement).disabled = false;
    (document.getElementById("coverageDescription") as HTMLInputElement).disabled = false;
    this.selectDisabled = false;
    (document.getElementById("typeCoverage") as HTMLInputElement).disabled = false;
    (document.getElementById("owsCoverage") as HTMLInputElement).disabled = false;
    (document.getElementById("months") as HTMLInputElement).disabled = false;
    (document.getElementById("distance") as HTMLInputElement).disabled = false;
    (document.getElementById("totalVisits") as HTMLInputElement).disabled = false;
    (document.getElementById("initialVisit") as HTMLInputElement).disabled = false;
    (document.getElementById("accountCode") as HTMLInputElement).disabled = false;
    (document.getElementById("actionCode") as HTMLInputElement).disabled = false;
    (document.getElementById("coverageCode") as HTMLInputElement).disabled = false;
    (document.getElementById("insuranceCode") as HTMLInputElement).disabled = false;
    (document.getElementById("titleDetails") as HTMLInputElement).style.display = 'none';
    (document.getElementById("titleEdit") as HTMLInputElement).style.display = 'block';
    (document.getElementById("subTitle") as HTMLInputElement).style.display = 'block';

  }

  buttonCancel() {
    this.isEditingMode = false;
    this.hasAttemptedSave = false;
    this.clearValidationState();

    this.getCoverageById();
    (document.getElementById("coverageIdName") as HTMLInputElement).disabled = true;
    (document.getElementById("coverageDescription") as HTMLInputElement).disabled = true;
    this.selectDisabled = true;
    (document.getElementById("typeCoverage") as HTMLInputElement).disabled = true;
    (document.getElementById("owsCoverage") as HTMLInputElement).disabled = true;
    (document.getElementById("months") as HTMLInputElement).disabled = true;
    (document.getElementById("distance") as HTMLInputElement).disabled = true;
    (document.getElementById("totalVisits") as HTMLInputElement).disabled = true;
    (document.getElementById("initialVisit") as HTMLInputElement).disabled = true;
    (document.getElementById("accountCode") as HTMLInputElement).disabled = true;
    (document.getElementById("actionCode") as HTMLInputElement).disabled = true;
    (document.getElementById("coverageCode") as HTMLInputElement).disabled = true;
    (document.getElementById("insuranceCode") as HTMLInputElement).disabled = true;

    (document.getElementById("titleDetails") as HTMLInputElement).style.display = 'block';
    (document.getElementById("titleEdit") as HTMLInputElement).style.display = 'none';
    (document.getElementById("subTitle") as HTMLInputElement).style.display = 'none';

    this.restoringValues();

  }

  private clearValidationState() {
    this.inputCoverageName = undefined;
    this.inputCoverageDescription = undefined;
    this.selectTypeCoverage = undefined;
    this.selectTypeCoverageGet = this.coverage?.type;
    this.inputOwsCoverage = undefined;
    this.inputMonths = undefined;
    this.inputDistance = undefined;
    this.inputDistanceString = undefined;
    this.inputTotalVisits = undefined;
    this.inputInitialVisit = undefined;
    this.editionEnabled = true;
  }

  optionCoverageTypeChange(event: DropdownChangeEvent<string | null | undefined>) {
    this.selectTypeCoverageGet = typeof event.value === 'string' ? event.value : '';
  }

  months(months: Event) {
    this.inputMonths = this.onlyAcceptNumbers
      .formatNumber(months);
  }

  totalVisits(totalVisits: Event) {
    this.inputTotalVisits = this.onlyAcceptNumbers
      .formatNumber(totalVisits);
  }

  initialVisit(initialVisit: Event) {
    this.inputInitialVisit = this.onlyAcceptNumbers
      .formatNumber(initialVisit);
  }

  formatOdometerNumber(event: Event) {

    const input = event.target as HTMLInputElement;
    let odometereTreatment = input.value;

    odometereTreatment = odometereTreatment.replace(/\D/g, "");
    odometereTreatment = odometereTreatment.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");

    input.value = odometereTreatment;

    const valueWithoutPoint = odometereTreatment.replace(/\./g, '').replace('.', ',');
    this.inputDistance = parseInt(valueWithoutPoint);

  }

  buttonSave() {

    this.hasAttemptedSave = true;

    this.editionEnabled = true;
    this.blockedUi = true;

    this.inputCoverageName = this.normalizeTextValue((document.getElementById("coverageIdName") as HTMLInputElement).value);
    this.inputCoverageDescription = this.normalizeTextValue((document.getElementById("coverageDescription") as HTMLInputElement).value);
    this.inputOwsCoverage = this.normalizeTextValue((document.getElementById("owsCoverage") as HTMLInputElement).value).toUpperCase();
    this.inputDistanceString = (document.getElementById("distance") as HTMLInputElement).value;
    this.selectTypeCoverage = this.selectTypeCoverageGet ?? this.coverage?.type;

    this.inputAccount = this.nullify((document.getElementById("accountCode") as HTMLInputElement)?.value);
    this.inputActionCode = this.nullify((document.getElementById("actionCode") as HTMLInputElement)?.value);
    this.inputCoverageCode = this.nullify((document.getElementById("coverageCode") as HTMLInputElement)?.value);
    this.inputInsuranceCode = (document.getElementById("insuranceCode") as HTMLInputElement)?.value;

    const insuranceTrimmed = this.inputInsuranceCode?.trim().toUpperCase() ?? '';
    const insuranceIsEmpty = insuranceTrimmed === '';
    if (insuranceIsEmpty) {
      this.inputInsuranceCode = undefined;
      this.blockedUi = false;
      this.editionEnabled = false;
    }

    if (!this.inputCoverageName) {

      this.inputCoverageName = null;
      this.blockedUi = false;
      this.editionEnabled = false;
    } else if (this.inputCoverageName.length < 4) {

      this.blockedUi = false;
      this.editionEnabled = false;
    }
    if (!this.inputCoverageDescription) {

      this.inputCoverageDescription = null;
      this.blockedUi = false;
      this.editionEnabled = false;
    } else if (this.inputCoverageDescription.length < 4) {

      this.blockedUi = false;
      this.editionEnabled = false;
    }
    if (!this.inputOwsCoverage) {

      this.inputOwsCoverage = null;
      this.blockedUi = false;
      this.editionEnabled = false;
    } else if (this.inputOwsCoverage.length < 4) {

      this.blockedUi = false;
      this.editionEnabled = false;
    }
    if (this.inputMonths === undefined ||
      this.inputMonths === null ||
      this.inputMonths < 0 ||
      this.inputMonths >= 100) {

      this.inputMonths = Number((document.getElementById("months") as HTMLInputElement).value);
    }
    if (this.inputMonths !== null && (isNaN(this.inputMonths) ||
      this.inputMonths <= 0)) {

      if (isNaN(this.inputMonths)) {
        this.inputMonths = null;
      }
      this.blockedUi = false;
      this.editionEnabled = false;
    }
    if (!this.selectTypeCoverage) {

      this.selectTypeCoverage = null;
      this.blockedUi = false;
      this.editionEnabled = false;
    }
    if (this.inputDistance === undefined) {
      this.inputDistance = parseInt(this.inputDistanceString.replace(/\./g, '').replace('.', ','));
    }
    if (this.inputDistance === null || this.inputDistance <= 0 || isNaN(this.inputDistance)) {

      if (isNaN(this.inputDistance)) {
        this.inputDistance = null;
      }
      this.blockedUi = false;
      this.editionEnabled = false;
    }
    if (this.inputTotalVisits === undefined) {

      this.inputTotalVisits = Number((document.getElementById("totalVisits") as HTMLInputElement).value);
    }
    if (this.inputTotalVisits === null || isNaN(this.inputTotalVisits) ||
      this.inputTotalVisits <= 0) {

      this.inputTotalVisits = null;
      this.blockedUi = false;
      this.editionEnabled = false;
    }
    if (this.inputInitialVisit === undefined) {

      this.inputInitialVisit = Number((document.getElementById("initialVisit") as HTMLInputElement).value);
    }
    if (this.inputInitialVisit === null || this.inputInitialVisit <= 0 ||
      isNaN(this.inputInitialVisit)) {

      this.inputInitialVisit = null;
      this.blockedUi = false;
      this.editionEnabled = false;
    }

    if (this.inputCoverageCode !== null && this.inputCoverageCode.length > 4) {

      this.inputCoverageCode = null;
      this.blockedUi = false;
      this.editionEnabled = false;

    }
    if (this.inputActionCode !== null && this.inputActionCode.length > 1) {

      this.inputActionCode = null;
      this.blockedUi = false;
      this.editionEnabled = false;

    }
    if (this.inputInsuranceCode !== undefined && this.inputInsuranceCode.length > 4) {

      this.inputInsuranceCode = undefined;
      this.blockedUi = false;
      this.editionEnabled = false;
    }

    if (!this.editionEnabled) {
      this.focusFirstInvalidField();
      if (!this.hasCoverageMinLengthError()) {
        this.messageService.add({
          severity: 'error',
          summary: this.translateService.instant('TRANSLATE.ERROR'),
          detail: this.translateService.instant('TRANSLATE.ERROR.PLEASE.REQUIRED.FIELDS')
        });
      }
      return;
    }

    if (this.editionEnabled) {

      this.editedCoverage.id = this.coverage.id;
      this.editedCoverage.name = this.inputCoverageName!;
      this.editedCoverage.description = this.inputCoverageDescription!;
      this.editedCoverage.visit = this.inputTotalVisits!;
      this.editedCoverage.startVisit = this.inputInitialVisit!;
      this.editedCoverage.planYear = this.coverage.planYear;
      this.editedCoverage.account = this.inputAccount;
      this.editedCoverage.actionCode = this.inputActionCode;
      this.editedCoverage.coverageCode = this.inputCoverageCode;
      this.editedCoverage.insuranceCode = this.nullify(this.inputInsuranceCode);
      this.editedCoverage.productId = this.coverage.productId;
      this.editedCoverage.productName = this.coverage.productName;
      this.editedCoverage.productCode = this.coverage.productCode;
      this.editedCoverage.country = this.coverage.country;
      this.editedCoverage.type = this.selectTypeCoverage!;
      this.editedCoverage.months = this.inputMonths!;
      this.editedCoverage.owsCoverage = this.inputOwsCoverage!;
      this.editedCoverage.updateUser = this.apsPermissionService.getUserCsid();
      this.editedCoverage.distance = this.inputDistance!;
      this.editCoverage(this.editedCoverage);

    }
  }


  private normalizeTextValue(value: string | null | undefined): string {
    return (value ?? '').trim();
  }

  isCoverageNameEmpty(): boolean {
    return this.isEditingMode && this.hasAttemptedSave && this.normalizeTextValue(this.inputCoverageName).length === 0;
  }

  isCoverageNameTooShort(): boolean {
    const value = this.normalizeTextValue(this.inputCoverageName);
    return this.isEditingMode && this.hasAttemptedSave && value.length > 0 && value.length < 4;
  }

  isCoverageDescriptionEmpty(): boolean {
    return this.isEditingMode && this.hasAttemptedSave && this.normalizeTextValue(this.inputCoverageDescription).length === 0;
  }

  isCoverageDescriptionTooShort(): boolean {
    const value = this.normalizeTextValue(this.inputCoverageDescription);
    return this.isEditingMode && this.hasAttemptedSave && value.length > 0 && value.length < 4;
  }

  isOwsCoverageEmpty(): boolean {
    return this.isEditingMode && this.hasAttemptedSave && this.normalizeTextValue(this.inputOwsCoverage).length === 0;
  }

  isOwsCoverageTooShort(): boolean {
    const value = this.normalizeTextValue(this.inputOwsCoverage);
    return this.isEditingMode && this.hasAttemptedSave && value.length > 0 && value.length < 4;
  }

  isMonthsEmpty(): boolean {
    return this.isEditingMode && this.hasAttemptedSave && (this.inputMonths === null || this.inputMonths === undefined);
  }

  isMonthsZeroOrLess(): boolean {
    return this.isEditingMode && this.hasAttemptedSave && this.inputMonths !== null && this.inputMonths !== undefined && this.inputMonths <= 0;
  }

  isDistanceEmpty(): boolean {
    return this.isEditingMode && this.hasAttemptedSave && (this.inputDistance === null || this.inputDistance === undefined);
  }

  isDistanceZeroOrLess(): boolean {
    return this.isEditingMode && this.hasAttemptedSave && this.inputDistance !== null && this.inputDistance !== undefined && this.inputDistance <= 0;
  }

  private hasCoverageMinLengthError(): boolean {
    return this.isCoverageNameTooShort()
      || this.isCoverageDescriptionTooShort()
      || this.isOwsCoverageTooShort();
  }

  getCoverageById() {

    this.blockedUi = true;
    this.coverageService.getSearchById(this.id).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(
      (response: CoverageCategoryEdit) => {
        this.coverage = response;
        this.productName = this.coverage.productId + " - " + this.coverage.productName + " - " + this.coverage.productCode;
        this.countryNameResult = this.countryName.getCountryName(this.coverage.country);
        this.distanceFormatted = this.formatDistance.odometerFormatting(this.coverage.distance);

        this.coverage.account = this.deNullify(this.coverage.account);
        this.coverage.actionCode = this.deNullify(this.coverage.actionCode);
        this.coverage.coverageCode = this.deNullify(this.coverage.coverageCode);
        this.coverage.insuranceCode = this.deNullify(this.coverage.insuranceCode);
        this.blockedUi = false;
        this.selectTypeCoverage = this.coverage.type;
        this.selectTypeCoverageGet = this.coverage.type;
      })
  }

  private deNullify(value: string | null | undefined): string {
    return (value === null || value === undefined) ? 'NULO' : value;
  }

  private nullify(value: string | null | undefined): string | null {
    const trimmed = (value || '').trim().toUpperCase();
    return (trimmed === '' || trimmed === 'NULO') ? null : trimmed;
  }

  editCoverage(editedCoverage: CoverageCategoryEdit) {

    this.coverageService.updateCoverage(editedCoverage)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {

          this.buttonCancel();
          this.getCoverageById();
          this.blockedUi = false;

          this.messageService.add({
            severity: 'success',
            summary: this.translateService.instant('TRANSLATE.SUCCESS'),
            detail: this.translateService.instant('TRANSLATE.SUCCESS.EDIT')
          });

        }, error: (err) => {

          this.blockedUi = false;

          if (err.status === 400) {

            this.messageService.add({
              severity: 'error',
              summary: this.translateService.instant('TRANSLATE.ERROR'),
              detail: this.translateService.instant('TRANSLATE.ERROR.PLEASE.REQUIRED.FIELDS')
            });

          } else if (err.status === 404) {

            this.messageService.add({
              severity: 'error',
              summary: this.translateService.instant('TRANSLATE.ERROR'),
              detail: this.translateService.instant('TRANSLATE.ERROR.SAVE.CHANGES')
            });

          } else if (err.status === 401) {

            this.messageService.add({
              severity: 'error',
              summary: this.translateService.instant('TRANSLATE.ERROR'),
              detail: this.translateService.instant('TRANSLATE.USER.WITHOUT.PERMISSION.REFRESH.PAGE')
            });

          } else {

            this.messageService.add({
              severity: 'error',
              summary: this.translateService.instant('TRANSLATE.ERROR'),
              detail: this.translateService.instant('TRANSLATE.ERROR.CONTACT.SYSTEM.ADMINISTRATOR')
            });
          }

        }

      });

  }

  restoringValues() {

    this.inputCoverageName = '';
    this.inputCoverageDescription = '';
    this.inputOwsCoverage = '';
    this.selectTypeCoverage = '';
    this.inputMonths = undefined;
    this.inputDistance = undefined;
    this.inputTotalVisits = undefined;
    this.inputInitialVisit = undefined;
  }

  private focusFirstInvalidField(): void {
    if (this.isCoverageNameEmpty() || this.isCoverageNameTooShort()) {
      this.focusFieldById('coverageIdName');
      return;
    }

    if (this.isCoverageDescriptionEmpty() || this.isCoverageDescriptionTooShort()) {
      this.focusFieldById('coverageDescription');
      return;
    }

    if (this.selectTypeCoverage === null || this.selectTypeCoverage === undefined || this.selectTypeCoverage === '') {
      this.focusFieldById('typeCoverage');
      return;
    }

    if (this.inputMonths === null || this.inputMonths === undefined || this.inputMonths <= 0) {
      this.focusFieldById('months');
      return;
    }

    if (this.inputDistance === null || this.inputDistance === undefined || this.inputDistance <= 0) {
      this.focusFieldById('distance');
      return;
    }

    if (this.inputTotalVisits === null || this.inputTotalVisits === undefined || this.inputTotalVisits <= 0) {
      this.focusFieldById('totalVisits');
      return;
    }

    if (this.inputInitialVisit === null || this.inputInitialVisit === undefined || this.inputInitialVisit <= 0) {
      this.focusFieldById('initialVisit');
      return;
    }

    if (this.isOwsCoverageEmpty() || this.isOwsCoverageTooShort()) {
      this.focusFieldById('owsCoverage');
      return;
    }

    if (this.inputInsuranceCode === undefined) {
      this.focusFieldById('insuranceCode');
    }
  }

  private focusFieldById(elementId: string): void {
    setTimeout(() => {
      const host = document.getElementById(elementId) as HTMLElement | null;
      if (!host) {
        return;
      }

      const focusableChild = host.querySelector('input, textarea, .p-dropdown-label, .p-multiselect-label, [tabindex]') as HTMLElement | null;
      const target = focusableChild ?? host;

      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      target.focus();
    }, 0);
  }

}
